// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2HoUI","itemTitle":"ClientEmergencyInfo_itemTitle__3kA3J","itemText":"ClientEmergencyInfo_itemText__mRc5l"};